import { useCustomerContext } from '@ovotech/ui-tools';
import React, { PropsWithChildren, useEffect } from 'react';
import { useLocation } from 'react-router-dom-v5';
import { ROUTE_HOME } from '@/src/constants/routes';
import {
  getRedirectDecision,
  setWebPreference,
} from '@/src/utils/webPreference';
import { NewWebRedirectDecision } from './NewWebRedirectDecision';

// Synchronous checks only — the decision component's queries must not mount on unredirectable routes.
export const NewWebRedirectGate = ({ children }: PropsWithChildren) => {
  const { pathname, search } = useLocation();
  const { customerId } = useCustomerContext();

  // Deep links into old web's home page always carry query params.
  const isBareHome = pathname === ROUTE_HOME && search === '';
  const decision = getRedirectDecision(customerId);
  const hasReturned = decision === 'returned-from-new-web';

  // Landing back here after we redirected them means they took the beta banner's
  // way out — new web doesn't write the cookie itself.
  useEffect(() => {
    if (isBareHome && hasReturned && customerId) {
      setWebPreference('legacy', customerId);
    }
  }, [isBareHome, hasReturned, customerId]);

  if (!isBareHome || decision !== 'allow') {
    return <>{children}</>;
  }

  return <NewWebRedirectDecision>{children}</NewWebRedirectDecision>;
};
